module.exports = __webpack_public_path__ + "img/trade-05.8f18eac5.png";